import { ConnectionOptions } from 'typeorm'

export interface ConnectionOptionsFactory {
  make(): ConnectionOptions
}

export class EnvironmentConnectionOptionsFactory implements ConnectionOptionsFactory {
  private readonly shared: Partial<ConnectionOptions>
  private readonly basic: Partial<ConnectionOptions> = {
    name: 'default'
  }

  constructor(shared: Partial<ConnectionOptions>) {
    this.shared = shared
  }

  public make(): ConnectionOptions {
    const ty = process.env.DB_TYPE
    switch (ty) {
      case 'postgres':
        return this.env_postgres(ty)
      case 'sqlite':
        return this.env_sqlite(ty)
      case 'mysql':
      case 'mariadb':
        return this.env_mysql(ty)
      default:
        throw new Error(`not supported database type: ${ty}`)
    }
  }

  private env_postgres(type: 'postgres'): ConnectionOptions {
    return {
      ...this.basic,
      ...this.shared,
      type,
      username: process.env.DB_USERNAME,
      password: process.env.DB_PASSWORD,
      database: process.env.DB_DATABASE,
      host: process.env.DB_HOST,
      port: parseInt(process.env.DB_PORT || '5432', 10)
    }
  }

  private env_mysql(type: 'mariadb' | 'mysql'): ConnectionOptions {
    return {
      ...this.basic,
      ...this.shared,
      type,
      username: process.env.DB_USERNAME,
      password: process.env.DB_PASSWORD,
      database: process.env.DB_DATABASE,
      host: process.env.DB_HOST,
      port: parseInt(process.env.DB_PORT || '3306', 10)
    }
  }

  private env_sqlite(type: 'sqlite'): ConnectionOptions {
    return {
      ...this.basic,
      ...this.shared,
      type,
      database: process.env.DB_DATABASE || 'database.sqlite'
    }
  }
}

export class TestConnectionOptionsFactory implements ConnectionOptionsFactory {
  private readonly shared: Partial<ConnectionOptions>
  private readonly basic: Partial<ConnectionOptions> = {
    name: 'default'
  }

  constructor(shared: Partial<ConnectionOptions>) {
    this.shared = shared
  }

  public make(): ConnectionOptions {
    return {
      ...this.basic,
      ...this.shared,
      type: 'sqlite',
      database: ':memory:'
    }
  }
}
